export default __webpack_public_path__ + "static/media/IBMCloudUpload.06d269be.svg";